import { LRUCache } from "lru-cache";
import * as APITypes from "~/API";
import { MAX_CACHE_ITEMS } from "./property";

export class UnitLRUCache {
  private static cache: LRUCache<string, APITypes.Unit>;

  public static getCacheInstance() {
    if (UnitLRUCache.cache) {
      return UnitLRUCache.cache;
    }

    UnitLRUCache.cache = new LRUCache<string, APITypes.Unit>({
      max: MAX_CACHE_ITEMS,
    });
    return UnitLRUCache.cache;
  }

  public static update({
    key,
    value,
  }: {
    key: string;
    value: APITypes.Unit;
  }) {
    if (!UnitLRUCache.cache) {
      UnitLRUCache.cache = new LRUCache<string, APITypes.Unit>({
        max: MAX_CACHE_ITEMS,
      });
    }

    UnitLRUCache.cache.set(key, value);
    return UnitLRUCache.cache;
  }

  /**
   * Clear the entire cache or a single element in the cache
   *
   * @param key optional: the key for the element to be removed from the cache.
   * If not passed, then entire cache is cleared
   * @returns
   */
  public static clear({ key }: { key?: string }) {
    if (!UnitLRUCache.cache) {
      UnitLRUCache.cache = new LRUCache<string, APITypes.Unit>({
        max: MAX_CACHE_ITEMS,
      });
    }

    if (key) {
      const isDeleted = UnitLRUCache.cache.delete(key);
      return {
        success: isDeleted,
        data: UnitLRUCache.cache,
        error: isDeleted
          ? new Error(`error deleting ${key} from the unit cache`)
          : null,
      };
    }

    UnitLRUCache.cache.clear();
    return {
      success: true,
      data: UnitLRUCache.cache,
    };
  }
}
